import { NavLink } from "react-router-dom";
import { Terminal, Heart } from "lucide-react";

const links = [
  { to: "/", label: "home", end: true },
  { to: "/models", label: "models" },
  { to: "/refinery", label: "refinery" },
  { to: "/library", label: "library" },
  { to: "/coach", label: "coach" },
  { to: "/techniques", label: "techniques" },
  { to: "/recap", label: "recap" },
  { to: "/adlab", label: "ad_lab" },
  { to: "/blog", label: "blog" },
  { to: "/shop", label: "shop" },
  { to: "/print-ready", label: "print_ready" },
  { to: "/whoracle", label: "whoracle" },
  { to: "/business", label: "business" },
];

export const Nav = ({ onDonate }) => (
  <header
    data-testid="global-nav"
    className="sticky top-0 z-30 backdrop-blur-xl bg-black/80 border-b border-white/10"
  >
    <div className="mx-auto max-w-7xl px-6 py-4 flex items-center justify-between gap-4">
      <NavLink to="/" data-testid="nav-home-logo" className="flex items-center gap-2 group flex-shrink-0">
        <Terminal className="w-4 h-4 text-[color:var(--accent-amber)]" />
        <span className="font-display font-bold tracking-tight text-sm">
          s<span className="text-[color:var(--accent-amber)]">A</span>
          <span className="text-[color:var(--accent-matrix)]">i</span>monSays
          <span className="text-neutral-500">.</span>
          <span className="text-[color:var(--accent-amber)]">A</span>
          <span className="text-[color:var(--accent-matrix)]">i</span>
        </span>
      </NavLink>
      <nav className="flex items-center gap-1 flex-wrap justify-end">
        {links.map((l) => (
          <NavLink
            key={l.to}
            to={l.to}
            end={l.end}
            data-testid={`nav-${l.label}`}
            className={({ isActive }) =>
              `px-3 py-1.5 text-xs uppercase tracking-widest border duration-150 ${
                isActive
                  ? "border-[color:var(--accent-amber)] text-[color:var(--accent-amber)]"
                  : "border-transparent text-neutral-400 hover:text-white hover:border-white/20"
              }`
            }
            style={{ transitionProperty: "color, border-color" }}
          >
            {l.label}
          </NavLink>
        ))}
        <button
          data-testid="nav-donate-btn"
          onClick={onDonate}
          className="ml-2 inline-flex items-center gap-1.5 bg-[color:var(--accent-amber)] text-black px-3 py-1.5 text-xs uppercase tracking-widest font-bold hover:bg-white duration-150"
          style={{ transitionProperty: "background-color" }}
        >
          <Heart className="w-3 h-3" /> donate
        </button>
      </nav>
    </div>
  </header>
);
